import React, { useState, useEffect } from "react";
import { Grid, Button, TextField, Alert } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ShuffleIcon from "@mui/icons-material/Shuffle";

const Groupmodify = (props) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [state, setState] = React.useState({
    groups: [],
    errorMessage: "",
    right: false,
    radioList: "A",
  });

  const handleSubmitClick = (e) => {
    e.preventDefault();
    const register = {
      groups: state.groups.toString(),
    };
    const UserID = props.UserID;
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/groupupdate/${UserID}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(register),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        window.location.reload();
      });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [userlist, setusers] = useState([]);
  useEffect(() => {
    const UserID = props.UserID;
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/user_list/${UserID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          localStorage.setItem("user_access", data.detail);
        } else {
          setusers(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [props.UserID]);

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  return (
    <>
      <Button
        onClick={handleClickOpen}
        startIcon={<ShuffleIcon />}
        color="primary"
        variant="contained"
        style={{ height: "28px", backgroundColor: "#ec407a" }}
      >
        Change Group
      </Button>
      <div style={{ alignItems: "center", display: "flex" }}>
        <div>
          {state.errorMessage && (
            <Alert color="danger" isOpen={visible} toggle={onDismiss}>
              {" "}
              {state.errorMessage}{" "}
            </Alert>
          )}
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Change Group</DialogTitle>
          <DialogContent>
            <Grid item md={20} xs={12}>
              <TextField
                fullWidth
                name="groups"
                id="groups"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={state.groups}
                variant="outlined"
                style={{ width: "300px" }}
              >
                {parseInt(userlist.groups) === 1 ? (
                  <React.Fragment>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                    <option value="3">OPS</option>
                    <option value="4">Trainer</option>
                    <option value="5">Trainee</option>
                  </React.Fragment>
                ) : parseInt(userlist.groups) === 2 ? (
                  <React.Fragment>
                    <option value="2">Read-Only</option>
                    <option value="1">Admin</option>
                    <option value="3">OPS</option>
                    <option value="4">Trainer</option>
                    <option value="5">Trainee</option>
                  </React.Fragment>
                ) : parseInt(userlist.groups) === 3 ? (
                  <React.Fragment>
                    <option value="3">OPS</option>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                    <option value="4">Trainer</option>
                    <option value="5">Trainee</option>
                  </React.Fragment>
                ) : parseInt(userlist.groups) === 4 ? (
                  <React.Fragment>
                    <option value="4">Trainer</option>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                    <option value="3">OPS</option>
                    <option value="5">Trainee</option>
                  </React.Fragment>
                ) : parseInt(userlist.groups) === 5 ? (
                  <React.Fragment>
                    <option value="5">Trainee</option>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                    <option value="3">OPS</option>
                    <option value="4">Trainer</option>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </TextField>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button type="submit" onClick={handleSubmitClick} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Groupmodify;
